import global from './globalVar'
import md5Model from 'md5'

// 获取cookie、
const getCookie = name => {
	let arr = []
	const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
	arr = document.cookie.match(reg)
	if (arr && arr.length > 0) {
		return (arr[2])
	}
	return null
}

// 设置cookie,增加到vue实例方便全局调用
const setCookie = (name, value, expiredays) => {
	let exdate = new Date()
	exdate.setDate(exdate.getDate() + Number(expiredays === undefined ? 1 : expiredays))
	document.cookie = name + '=' + encodeURIComponent(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toUTCString() + ';path=/')
}

// 删除cookie
const delCookie = name => {
	const exp = new Date()
	exp.setDate(exp.getDate() - 1)
	const cval = getCookie(name)
	if (cval !== null) {
		document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString() + ';path=/'
	}
}

// 获取动态设置字体
const setFont = no => {
	const scale = document.documentElement.clientWidth / 750
	return no * Math.min(scale, 1)
}

const getURLWithContext = path => {
	let { region, lang } = global;
	if (path && path[0] === '/') {
		path = path.splice(1);
	}
	return `/mobile/${region}/${lang}/${path}`;
}
const getDynamicURLWithContextNew = path => {
	let { region, lang } = global;
	if (path && path[0] === '/') {
		path = path.splice(1);
	}
	return `/${region}/${lang}/dynamic_functions/${path}`;
}
const getDynamicURLWithContext = path => getURLWithContext(`dynamic_function/${path}`)

/**
 * 解析url对应的参数
 * @param key
 * @param url 地址
 * @returns 参数名下的参数值 （value） 否则返回 false
 */
const getUrlParm = (key, url) => {
	const params = url.split('&')
	let	result = null
	url = url.substring(url.indexOf('?'))
	if (url.length === 0) return false
	if (url.charAt(0) !== '?' && url.charAt(0) !== '#') return false
	for (let i = 0; i < params.length; i++) {
		if (params[i].indexOf(key) >= 0) {
			result = params[i].split('=')
			result = result[1]
		}
	}
	return result
}

//search,查询？后面的参数，并匹配正则
const getQueryString = name => {
	let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
	let r = window.location.search.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
}

/**
 * 校验运单号
 */
const verifyBillNumber = billNumber => {
	const re = /^\d{12}$|^SF\d{13}$|^9901\d{11}/
    return re.test(billNumber.trim())
}

const getHighHtml = (str, key = '') => {
	if (!str) return ''
	if (!key) return str
	const regexp = new RegExp(`(${key})`, 'g')
	return str.replace(regexp, '<i>$1</i>')
}

/**
 * randomWord 产生任意长度随机字母数字组合
 * @param randomFlag 是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 * @param min
 * @param max
 * @returns {string}
 */
const randomWord = (randomFlag, min, max) => {
    let str = ''
    let range = min
    const arr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
    ]

    // 随机产生
    if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min
    }
    for (let i = 0; i < range; i++) {
        const pos = Math.round(Math.random() * (arr.length - 1))
        str += arr[pos]
    }
    return str
}

/**
 * signMD5 接入标签MD5加密
 * @param params (appId、appSecret、body)按顺序传，body没有就不传
 * @returns {appId, nonce, timestamp, sign}
 */
const signMD5 = params => {
    const { appId, appSecret } = params
    if (!appId || !appSecret) {
        return { appId: '', nonce: '', timestamp: '', sign: '' }
    }
    // 随机字符串
    const nonce = randomWord(false, 6)
    const timestamp = new Date().getTime() // 时间戳
    const tempParams = {
        ...params,
        nonce,
        timestamp
    }
    // 根据key的字母进行排序拼接
    const tempParamsKeys = Object.keys(tempParams).sort()
    let signParam = ''
    tempParamsKeys.forEach((key, index) => {
        if (key === 'body') {
            signParam = `${signParam}${key}=${JSON.stringify(tempParams[key])}${index === tempParamsKeys.length - 1 ? '' : '&'}`
        } else {
            signParam = `${signParam}${key}=${tempParams[key]}${index === tempParamsKeys.length - 1 ? '' : '&'}`
        }
    })
    const sign = md5Model(signParam)
    return {
        appId,
        nonce,
        timestamp,
        sign
    }
}

export {
	getCookie,
	setCookie,
	delCookie,
	setFont,
	getURLWithContext,
	getDynamicURLWithContext,
	getDynamicURLWithContextNew,
	getUrlParm,
	getQueryString,
	verifyBillNumber,
	getHighHtml,
	signMD5
}



// WEBPACK FOOTER //
// ./src/util/util.js